export default {
  agency_key: '',
  mode: '',
  beian: '',
  beian_gn: '',


  chat_url: '',
  address: '上海市徐汇区宜山路700号A7楼709',
  uc_host: 'https://i.ruanmeihui.net',
  site_host: 'https://www.ruanmeihui.net',
  special_url: '/',
  site_title: '软媒汇-软文精准营销平台',
  welcome_title: '软媒汇 — 软文精准营销平台！',
  site_short_title: '软媒汇',
  site_subtitle: '软文精准营销平台',
  company_name: '上海市匡桑网络科技有限公司',
  copyright: '© 2020 上海市匡桑网络科技有限公司',
  logo: 'https://www.ruanmeihui.net/2.0/images/public/logo.png',
  favicon: 'https://www.ruanmeihui.net/favicon.ico',
  payment: '',
  qq: '2079874893',
  tel: '13501607042',
  recharge_tel: '400-6765-660',
  company_account_id: '42050110239900000416',
  company_bank: '中国建设银行股份有限公司武汉软件园科技支行',
  company_bank_name: '上海市匡桑网络科技有限公司',
  alipay_account_id: '',
  alipay_name: '',
  alipay_pic: '',
  section_id: 0,
  belonger_id: 0,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 